module.exports = __webpack_public_path__ + "static/media/site.4e294add.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/site.svg
// module id = 132
// module chunks = 0